(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TokenAPIService', tokenAPIService);

    function tokenAPIService(HttpService) {
        /**
         * Get token by using the Shopify cookie if any
         */
        function getShopifyLoginToken() {
            const data = $.param({
                grant_type: 'shopify'
            });

            return HttpService.post('/token', data, 'application/x-www-form-urlencoded').then(function (data) {
                return data;
            });
        }

        return {
            getShopifyLoginToken: getShopifyLoginToken
        };
    }
})();
